<template>
  <div>
    <mia-is-allowed
      to="customer_portal"
      who="dealer"
    >
      <h1>Kundenkommunikation</h1>

      <mia-wait :for="['loading settings','loading forms']">
        <template #waiting>
          <div class="flex items-center justify-center py-8">
            <mia-wave-loader />
          </div>
        </template>

        <div class="flex">
          <div class="flex-shrink-0 w-56">
            <mia-settings-css-menu
              :forms="forms"
              class="sticky top-0"
            />
          </div>

          <div class="flex-1 ml-8">
            <router-view />
          </div>
        </div>
      </mia-wait>
    </mia-is-allowed>
  </div>
</template>

<script>
import SettingsCssMenu from '@/components/settings/SettingsCssMenu.vue'
import { getCustomerCommunicationForms } from '@/api/settings'

export default {
  components: {
    'mia-settings-css-menu': SettingsCssMenu
  },

  data() {
    return {
      forms: null
    }
  },

  async created() {
    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/settings'
        },
        text: 'System'
      },
      {
        link: {
          path: '/settings/customer-portal'
        },
        text: 'Kundenportal'
      }
    ])

    this.$wait.start('loading settings')
    await this.$store.dispatch('settings/loadSettings')
    this.$wait.end('loading settings')
  },

  mounted() {
    this.getCommunicationForms()
    console.log('test')
  },

  methods: {
    async getCommunicationForms() {
      this.$wait.start('loading forms')
      const [error, forms] = await getCustomerCommunicationForms()

      this.$wait.end('loading forms')
      this.forms = forms.data
    }

  }
}
</script>
